"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6930],{

/***/ 18872:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "iv": function() { return /* binding */ css; },
  "cx": function() { return /* binding */ cx; },
  "F4": function() { return /* binding */ keyframes; }
});

// UNUSED EXPORTS: cache, flush, getRegisteredStyles, hydrate, injectGlobal, merge, sheet

// EXTERNAL MODULE: ./node_modules/@emotion/cache/dist/emotion-cache.browser.esm.js + 7 modules
var emotion_cache_browser_esm = __webpack_require__(48711);
// EXTERNAL MODULE: ./node_modules/@emotion/serialize/dist/emotion-serialize.esm.js + 2 modules
var emotion_serialize_esm = __webpack_require__(85662);
// EXTERNAL MODULE: ./node_modules/@emotion/utils/dist/emotion-utils.browser.esm.js
var emotion_utils_browser_esm = __webpack_require__(70444);
;// CONCATENATED MODULE: ./node_modules/@emotion/css/create-instance/dist/emotion-css-create-instance.esm.js




function insertWithoutScoping(cache, serialized) {
  if (cache.inserted[serialized.name] === undefined) {
    return cache.insert('', serialized, cache.sheet, true);
  }
}

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = (0,emotion_utils_browser_esm/* getRegisteredStyles */.fp)(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var createEmotion = function createEmotion(options) {
  var cache = (0,emotion_cache_browser_esm/* default */.Z)(options); // $FlowFixMe

  cache.sheet.speedy = function (value) {
    if (false) {}

    this.isSpeedy = value;
  };

  cache.compat = true;

  var css = function css() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = (0,emotion_serialize_esm/* serializeStyles */.O)(args, cache.registered, undefined);
    (0,emotion_utils_browser_esm/* insertStyles */.My)(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var keyframes = function keyframes() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var serialized = (0,emotion_serialize_esm/* serializeStyles */.O)(args, cache.registered);
    var animation = "animation-" + serialized.name;
    insertWithoutScoping(cache, {
      name: serialized.name,
      styles: "@keyframes " + animation + "{" + serialized.styles + "}"
    });
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var serialized = (0,emotion_serialize_esm/* serializeStyles */.O)(args, cache.registered);
    insertWithoutScoping(cache, serialized);
  };

  var cx = function cx() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return merge(cache.registered, css, classnames(args));
  };

  return {
    css: css,
    cx: cx,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    hydrate: function hydrate(ids) {
      ids.forEach(function (key) {
        cache.inserted[key] = true;
      });
    },
    flush: function flush() {
      cache.registered = {};
      cache.inserted = {};
      cache.sheet.flush();
    },
    // $FlowFixMe
    sheet: cache.sheet,
    cache: cache,
    getRegisteredStyles: emotion_utils_browser_esm/* getRegisteredStyles.bind */.fp.bind(null, cache.registered),
    merge: merge.bind(null, cache.registered, css)
  };
};

var classnames = function classnames(args) {
  var cls = '';

  for (var i = 0; i < args.length; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};



;// CONCATENATED MODULE: ./node_modules/@emotion/css/dist/emotion-css.esm.js





var _createEmotion = createEmotion({
  key: 'css'
}),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    emotion_css_esm_merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    cache = _createEmotion.cache;




/***/ }),

/***/ 56930:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96649);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82772);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_array_slice_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47042);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96078);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_freeze_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(43371);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(33948);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(67294);
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(18872);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(70917);
/* harmony import */ var _system_index_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26153);
/* harmony import */ var _theme_eero_index_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(81762);
/* harmony import */ var _theme_legacy_foundations_mediaBreakpoints_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(26009);
/* harmony import */ var _Box_index_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(8013);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

















var _templateObject;
var _excluded = ["padding"],
  _excluded2 = ["size", "borderWidth"],
  _excluded3 = ["padding", "shade"];
function cov_1n7b87ze7d() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Loader/Loader.tsx";
  var hash = "986788f455ac19b341fbb05050b753a781e376c6";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Loader/Loader.tsx",
    statementMap: {
      "0": {
        start: {
          line: 19,
          column: 80
        },
        end: {
          line: 30,
          column: 1
        }
      },
      "1": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 29,
          column: 4
        }
      },
      "2": {
        start: {
          line: 32,
          column: 21
        },
        end: {
          line: 40,
          column: 1
        }
      },
      "3": {
        start: {
          line: 42,
          column: 20
        },
        end: {
          line: 45,
          column: 1
        }
      },
      "4": {
        start: {
          line: 47,
          column: 18
        },
        end: {
          line: 50,
          column: 1
        }
      },
      "5": {
        start: {
          line: 52,
          column: 25
        },
        end: {
          line: 59,
          column: 1
        }
      },
      "6": {
        start: {
          line: 61,
          column: 22
        },
        end: {
          line: 80,
          column: 1
        }
      },
      "7": {
        start: {
          line: 62,
          column: 2
        },
        end: {
          line: 79,
          column: 4
        }
      },
      "8": {
        start: {
          line: 82,
          column: 78
        },
        end: {
          line: 102,
          column: 1
        }
      },
      "9": {
        start: {
          line: 87,
          column: 2
        },
        end: {
          line: 101,
          column: 4
        }
      },
      "10": {
        start: {
          line: 104,
          column: 14
        },
        end: {
          line: 106,
          column: 1
        }
      },
      "11": {
        start: {
          line: 108,
          column: 15
        },
        end: {
          line: 110,
          column: 1
        }
      },
      "12": {
        start: {
          line: 112,
          column: 13
        },
        end: {
          line: 114,
          column: 1
        }
      },
      "13": {
        start: {
          line: 116,
          column: 13
        },
        end: {
          line: 118,
          column: 1
        }
      },
      "14": {
        start: {
          line: 120,
          column: 33
        },
        end: {
          line: 143,
          column: 1
        }
      },
      "15": {
        start: {
          line: 121,
          column: 25
        },
        end: {
          line: 125,
          column: 3
        }
      },
      "16": {
        start: {
          line: 127,
          column: 22
        },
        end: {
          line: 132,
          column: 3
        }
      },
      "17": {
        start: {
          line: 134,
          column: 2
        },
        end: {
          line: 142,
          column: 4
        }
      },
      "18": {
        start: {
          line: 144,
          column: 0
        },
        end: {
          line: 144,
          column: 30
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 19,
            column: 80
          },
          end: {
            line: 19,
            column: 81
          }
        },
        loc: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 29,
            column: 4
          }
        },
        line: 23
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 61,
            column: 22
          },
          end: {
            line: 61,
            column: 23
          }
        },
        loc: {
          start: {
            line: 62,
            column: 2
          },
          end: {
            line: 79,
            column: 4
          }
        },
        line: 62
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 82,
            column: 78
          },
          end: {
            line: 82,
            column: 79
          }
        },
        loc: {
          start: {
            line: 87,
            column: 2
          },
          end: {
            line: 101,
            column: 4
          }
        },
        line: 87
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 120,
            column: 33
          },
          end: {
            line: 120,
            column: 34
          }
        },
        loc: {
          start: {
            line: 120,
            column: 67
          },
          end: {
            line: 143,
            column: 1
          }
        },
        line: 120
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 27,
            column: 8
          },
          end: {
            line: 27,
            column: 39
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 27,
            column: 29
          },
          end: {
            line: 27,
            column: 30
          }
        }, {
          start: {
            line: 27,
            column: 33
          },
          end: {
            line: 27,
            column: 39
          }
        }],
        line: 27
      },
      "1": {
        loc: {
          start: {
            line: 90,
            column: 14
          },
          end: {
            line: 90,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 90,
            column: 14
          },
          end: {
            line: 90,
            column: 18
          }
        }, {
          start: {
            line: 90,
            column: 22
          },
          end: {
            line: 90,
            column: 24
          }
        }],
        line: 90
      },
      "2": {
        loc: {
          start: {
            line: 91,
            column: 15
          },
          end: {
            line: 91,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 91,
            column: 15
          },
          end: {
            line: 91,
            column: 19
          }
        }, {
          start: {
            line: 91,
            column: 23
          },
          end: {
            line: 91,
            column: 25
          }
        }],
        line: 91
      },
      "3": {
        loc: {
          start: {
            line: 94,
            column: 19
          },
          end: {
            line: 94,
            column: 39
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 94,
            column: 26
          },
          end: {
            line: 94,
            column: 34
          }
        }, {
          start: {
            line: 94,
            column: 37
          },
          end: {
            line: 94,
            column: 39
          }
        }],
        line: 94
      },
      "4": {
        loc: {
          start: {
            line: 95,
            column: 20
          },
          end: {
            line: 95,
            column: 40
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 95,
            column: 27
          },
          end: {
            line: 95,
            column: 35
          }
        }, {
          start: {
            line: 95,
            column: 38
          },
          end: {
            line: 95,
            column: 40
          }
        }],
        line: 95
      },
      "5": {
        loc: {
          start: {
            line: 96,
            column: 20
          },
          end: {
            line: 96,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 96,
            column: 20
          },
          end: {
            line: 96,
            column: 31
          }
        }, {
          start: {
            line: 96,
            column: 35
          },
          end: {
            line: 96,
            column: 36
          }
        }],
        line: 96
      },
      "6": {
        loc: {
          start: {
            line: 130,
            column: 18
          },
          end: {
            line: 130,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 130,
            column: 18
          },
          end: {
            line: 130,
            column: 34
          }
        }, {
          start: {
            line: 130,
            column: 38
          },
          end: {
            line: 130,
            column: 57
          }
        }],
        line: 130
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "986788f455ac19b341fbb05050b753a781e376c6"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1n7b87ze7d = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1n7b87ze7d();
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/** @jsx jsx */







cov_1n7b87ze7d().s[0]++;
var Section = function Section(_ref) {
  var padding = _ref.padding,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_1n7b87ze7d().f[0]++;
  cov_1n7b87ze7d().s[1]++;
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_19__/* .jsx */ .tZ)(_system_index_mjs__WEBPACK_IMPORTED_MODULE_20__/* .bricks.section */ .G.section, _extends({
    maxWidth: "".concat(_theme_legacy_foundations_mediaBreakpoints_mjs__WEBPACK_IMPORTED_MODULE_21__/* .BREAKPOINTS_DICT.XL */ .lU.XL, "px"),
    mx: "auto",
    textAlign: "center",
    py: padding === 'none' ? (cov_1n7b87ze7d().b[0][0]++, 0) : (cov_1n7b87ze7d().b[0][1]++, '2rem')
  }, props));
};
var extraPadding = (cov_1n7b87ze7d().s[2]++, /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_19__/* .css */ .iv)("padding-top:6rem;padding-bottom:5rem;", _theme_legacy_foundations_mediaBreakpoints_mjs__WEBPACK_IMPORTED_MODULE_21__/* .media.smallerThan.SM */ .BC.smallerThan.SM, "{padding-top:4rem;padding-bottom:4rem;}" + ( true ? "" : 0),  true ? "" : 0));
var lessPadding = (cov_1n7b87ze7d().s[3]++,  true ? {
  name: "x01ejq",
  styles: "padding-top:1rem;padding-bottom:1rem"
} : 0);
var noPadding = (cov_1n7b87ze7d().s[4]++,  true ? {
  name: "1fde9eo",
  styles: "padding-top:0;padding-bottom:0"
} : 0);
var inProgressRotate = (cov_1n7b87ze7d().s[5]++, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_19__/* .keyframes */ .F4)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"]))));
cov_1n7b87ze7d().s[6]++;
var LoaderWrapper = function LoaderWrapper(props) {
  cov_1n7b87ze7d().f[1]++;
  cov_1n7b87ze7d().s[7]++;
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_19__/* .jsx */ .tZ)(_Box_index_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, _extends({
    display: "inline-block",
    position: "relative",
    width: "18px",
    height: "18px",
    sx: {
      '& div:nth-of-type(1)': {
        animationDelay: '-0.45s'
      },
      '& div:nth-of-type(2)': {
        animationDelay: '-0.3s'
      },
      '& div:nth-of-type(3)': {
        animationDelay: '-0.15s'
      }
    }
  }, props));
};
cov_1n7b87ze7d().s[8]++;
var Spinner = function Spinner(_ref2) {
  var _ref3, _ref4, _ref5;
  var size = _ref2.size,
    borderWidth = _ref2.borderWidth,
    props = _objectWithoutProperties(_ref2, _excluded2);
  cov_1n7b87ze7d().f[2]++;
  cov_1n7b87ze7d().s[9]++;
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_19__/* .jsx */ .tZ)(_Box_index_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, _extends({
    boxSizing: "border-box",
    position: "absolute",
    width: "".concat((_ref3 = (cov_1n7b87ze7d().b[1][0]++, size)) !== null && _ref3 !== void 0 ? _ref3 : (cov_1n7b87ze7d().b[1][1]++, 24), "px"),
    height: "".concat((_ref4 = (cov_1n7b87ze7d().b[2][0]++, size)) !== null && _ref4 !== void 0 ? _ref4 : (cov_1n7b87ze7d().b[2][1]++, 24), "px"),
    top: "50%",
    left: "50%",
    marginTop: "-".concat(size ? (cov_1n7b87ze7d().b[3][0]++, size / 2) : (cov_1n7b87ze7d().b[3][1]++, 12), "px"),
    marginLeft: "-".concat(size ? (cov_1n7b87ze7d().b[4][0]++, size / 2) : (cov_1n7b87ze7d().b[4][1]++, 12), "px"),
    borderWidth: "".concat((_ref5 = (cov_1n7b87ze7d().b[5][0]++, borderWidth)) !== null && _ref5 !== void 0 ? _ref5 : (cov_1n7b87ze7d().b[5][1]++, 3), "px"),
    borderStyle: "solid",
    borderRadius: "full",
    animation: " 0.6s linear 0s infinite normal none running ".concat(inProgressRotate)
  }, props));
};
var light = (cov_1n7b87ze7d().s[10]++, /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_19__/* .css */ .iv)("border-color:", _theme_eero_index_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"].neutrals0 */ .ZP.neutrals0, " transparent transparent transparent;" + ( true ? "" : 0),  true ? "" : 0));
var medium = (cov_1n7b87ze7d().s[11]++, /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_19__/* .css */ .iv)("border-color:", _theme_eero_index_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"].neutrals30 */ .ZP.neutrals30, " transparent transparent transparent;" + ( true ? "" : 0),  true ? "" : 0));
var dark = (cov_1n7b87ze7d().s[12]++, /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_19__/* .css */ .iv)("border-color:", _theme_eero_index_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"].neutrals100 */ .ZP.neutrals100, " transparent transparent transparent;" + ( true ? "" : 0),  true ? "" : 0));
var blue = (cov_1n7b87ze7d().s[13]++, /*#__PURE__*/(0,_emotion_react__WEBPACK_IMPORTED_MODULE_19__/* .css */ .iv)("border-color:", _theme_eero_index_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"].brand50 */ .ZP.brand50, " transparent transparent transparent;" + ( true ? "" : 0),  true ? "" : 0));
cov_1n7b87ze7d().s[14]++;
var Loader = function Loader(_ref6) {
  var padding = _ref6.padding,
    shade = _ref6.shade,
    props = _objectWithoutProperties(_ref6, _excluded3);
  cov_1n7b87ze7d().f[3]++;
  var sectionPadding = (cov_1n7b87ze7d().s[15]++, (0,_emotion_css__WEBPACK_IMPORTED_MODULE_18__.cx)(_defineProperty({}, /*#__PURE__*/(0,_emotion_css__WEBPACK_IMPORTED_MODULE_18__/* .css */ .iv)(extraPadding,  true ? "" : 0,  true ? "" : 0), padding === 'extra'), _defineProperty({}, /*#__PURE__*/(0,_emotion_css__WEBPACK_IMPORTED_MODULE_18__/* .css */ .iv)(lessPadding,  true ? "" : 0,  true ? "" : 0), padding === 'less'), _defineProperty({}, /*#__PURE__*/(0,_emotion_css__WEBPACK_IMPORTED_MODULE_18__/* .css */ .iv)(noPadding,  true ? "" : 0,  true ? "" : 0), padding === 'none')));
  var loaderColor = (cov_1n7b87ze7d().s[16]++, (0,_emotion_css__WEBPACK_IMPORTED_MODULE_18__.cx)(_defineProperty({}, /*#__PURE__*/(0,_emotion_css__WEBPACK_IMPORTED_MODULE_18__/* .css */ .iv)(blue,  true ? "" : 0,  true ? "" : 0), shade === 'blue'), _defineProperty({}, /*#__PURE__*/(0,_emotion_css__WEBPACK_IMPORTED_MODULE_18__/* .css */ .iv)(light,  true ? "" : 0,  true ? "" : 0), shade === 'light'), _defineProperty({}, /*#__PURE__*/(0,_emotion_css__WEBPACK_IMPORTED_MODULE_18__/* .css */ .iv)(dark,  true ? "" : 0,  true ? "" : 0), (cov_1n7b87ze7d().b[6][0]++, shade === 'dark') || (cov_1n7b87ze7d().b[6][1]++, shade === undefined)), _defineProperty({}, /*#__PURE__*/(0,_emotion_css__WEBPACK_IMPORTED_MODULE_18__/* .css */ .iv)(medium,  true ? "" : 0,  true ? "" : 0), shade === 'medium')));
  cov_1n7b87ze7d().s[17]++;
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_19__/* .jsx */ .tZ)(Section, {
    className: sectionPadding,
    padding: padding
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_19__/* .jsx */ .tZ)(LoaderWrapper, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_19__/* .jsx */ .tZ)(Spinner, _extends({}, props, {
    className: loaderColor
  })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_19__/* .jsx */ .tZ)(Spinner, _extends({}, props, {
    className: loaderColor
  })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_19__/* .jsx */ .tZ)(Spinner, _extends({}, props, {
    className: loaderColor
  }))));
};
cov_1n7b87ze7d().s[18]++;
Loader.displayName = 'Loader';
/* harmony default export */ __webpack_exports__["Z"] = (Loader);

/***/ })

}]);